import Router from 'next/router';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import * as actionTypes from '../actionTypes';
import {
  createProductApi,
  getAllProductsApi,
  getCurrentProductApi,
  getSimilarProductsApi,
  getUserProductsApi,
  updateUserProductStatusApi,
  deleteUserProductApi,
  editUserProductApi,
  getCurrentUserProductApi,
  sendProductComplaintApi,
} from '../../api/apiUrls/product';

const getAllProductsStart = () => ({ type: actionTypes.GET_ALL_PRODUCTS_START });
const getAllProductsSuccess = (payload) => ({
  type: actionTypes.GET_ALL_PRODUCTS_SUCCESS,
  payload,
});
const getAllProductsFail = (error) => ({ type: actionTypes.GET_ALL_PRODUCTS_FAIL, error });

const getAllProducts = (data, showMore = false) => (dispatch) => {
  dispatch(getAllProductsStart());

  return getAllProductsApi(data)
    .then((response) => {
      if (response.status === 200) {
        dispatch(getAllProductsSuccess({
          ...response.data,
          showMore,
        }));
      }
    })
    .catch((error) => {
      dispatch(getAllProductsFail(error));
    });
};

const getCurrentProductStart = () => ({ type: actionTypes.GET_CURRENT_PRODUCT_START });
const getCurrentProductSuccess = (payload) => ({
  type: actionTypes.GET_CURRENT_PRODUCT_SUCCESS,
  payload,
});
const getCurrentProductFail = (error) => ({ type: actionTypes.GET_CURRENT_PRODUCT_FAIL, error });
const removeCurrentProduct = () => ({ type: actionTypes.REMOVE_CURRENT_PRODUCT });

const getCurrentProduct = (productLink, params, token = null, headers) => (dispatch) => {
  dispatch(getCurrentProductStart());

  return getCurrentProductApi(productLink, params, token, headers)
    .then((response) => {
      if (response.data.success) {
        dispatch(getCurrentProductSuccess(response.data.data));
      }
    }).catch((error) => {
      dispatch(getCurrentProductFail(error));
    });
};

const getSimilarProductsStart = () => ({ type: actionTypes.GET_SIMILAR_PRODUCTS_START });
const getSimilarProductsSuccess = (payload) => ({
  type: actionTypes.GET_SIMILAR_PRODUCTS_SUCCESS,
  payload,
});
const getSimilarProductsFail = (error) => ({
  type: actionTypes.GET_SIMILAR_PRODUCTS_SUCCESS,
  error,
});

const getSimilarProducts = (productLink) => (dispatch) => {
  dispatch(getSimilarProductsStart());

  return getSimilarProductsApi(productLink)
    .then((response) => {
      if (response.data.success) {
        dispatch(getSimilarProductsSuccess(response.data.data));
      }
    })
    .catch((error) => {
      dispatch(getSimilarProductsFail(error));
    });
};

const getSearchAllProductsStart = () => ({ type: actionTypes.GET_SEARCH_ALL_PRODUCTS_START });
const getSearchAllProductsSuccess = (payload) => ({
  type: actionTypes.GET_SEARCH_ALL_PRODUCTS_SUCCESS,
  payload,
});
const getSearchAllProductsFail = (error) => ({
  type: actionTypes.GET_SEARCH_ALL_PRODUCTS_FAIL,
  error,
});

const getSearchAllProducts = (params) => (dispatch) => {
  dispatch(getSearchAllProductsStart());

  return getAllProductsApi(params)
    .then((response) => {
      if (response.data.success) {
        dispatch(getSearchAllProductsSuccess(response.data));
      }
    })
    .catch((error) => {
      dispatch(getSearchAllProductsFail(error));
    });
};

const createProductStart = () => ({ type: actionTypes.CREATE_PRODUCT_START });
const createProductSuccess = (payload) => ({
  type: actionTypes.CREATE_PRODUCT_SUCCESS,
  payload,
});
const createProductFail = (error) => ({
  type: actionTypes.CREATE_PRODUCT_FAIL,
  error,
});

const createProduct = (data, token) => (dispatch) => {
  dispatch(createProductStart());

  return createProductApi(data, token)
    .then((response) => {
      if (response.data.success) {
        Router.push('/cabinet/gallery');
        dispatch(createProductSuccess(response.data));
        NotificationManager.success('Product created');
      }
    })
    .catch((error) => {
      dispatch(createProductFail(error));
    });
};

const getUserProductsStart = () => ({ type: actionTypes.GET_USER_PRODUCTS_START });
const getUserProductsSuccess = (payload) => ({
  type: actionTypes.GET_USER_PRODUCTS_SUCCESS,
  payload,
});
const getUserProductsFail = (error) => ({
  type: actionTypes.GET_USER_PRODUCTS_FAIL,
  error,
});

const getUserProducts = (params, token) => (dispatch) => {
  dispatch(getUserProductsStart());

  return getUserProductsApi(params, token)
    .then((response) => {
      if (response.data.success) {
        dispatch(getUserProductsSuccess({
          ...response.data,
        }));
      }
    })
    .catch((error) => {
      dispatch(getUserProductsFail(error));
    });
};

const changeProductInfo = (data) => (dispatch) => {
  dispatch({ type: actionTypes.CHANGE_PRODUCT_INFO, payload: data });
};

const getCurrentProductBid = (data) => (dispatch) => {
  dispatch({ type: actionTypes.GET_CURRENT_PRODUCT_BID, payload: data.bid });
};

const updateUserProductStatusStart = () => ({ type: actionTypes.UPDATE_USER_PRODUCT_STATUS_START });
const updateUserProductStatusSuccess = (payload) => ({
  type: actionTypes.UPDATE_USER_PRODUCT_STATUS_SUCCESS,
  payload,
});
const updateUserProductStatusFail = (error) => ({
  type: actionTypes.UPDATE_USER_PRODUCT_STATUS_FAIL,
  error,
});

const updateUserProductStatus = (params, token) => (dispatch) => {
  dispatch(updateUserProductStatusStart());

  return updateUserProductStatusApi(params, token)
    .then((response) => {
      if (response.data.success) {
        dispatch(updateUserProductStatusSuccess({
          ...response.data,
        }));
      }
    }).catch((error) => {
      dispatch(updateUserProductStatusFail(error));
    });
};

const deleteUserProductStart = () => ({ type: actionTypes.DELETE_USER_PRODUCT_START });
const deleteUserProductSuccess = (payload) => ({
  type: actionTypes.DELETE_USER_PRODUCT_SUCCESS,
  payload,
});
const deleteUserProductFail = (error) => ({
  type: actionTypes.DELETE_USER_PRODUCT_FAIL,
  error,
});

const deleteUserProduct = (params, token) => (dispatch) => {
  dispatch(deleteUserProductStart());

  return deleteUserProductApi(params, token)
    .then((response) => {
      if (response.data.success) {
        dispatch(deleteUserProductSuccess({
          ...response.data,
        }));
        NotificationManager.success('Product deleted');
      }
    }).catch((error) => {
      dispatch(deleteUserProductFail(error));
    });
};

const editUserProductStart = () => ({ type: actionTypes.EDIT_USER_PRODUCT_START });
const editUserProductSuccess = (payload) => ({
  type: actionTypes.EDIT_USER_PRODUCT_SUCCESS,
  payload,
});
const editUserProductFail = (error) => ({
  type: actionTypes.EDIT_USER_PRODUCT_FAIL,
  error,
});

const editUserProduct = (data, link, token) => (dispatch) => {
  dispatch(editUserProductStart());

  return editUserProductApi(data, link, token)
    .then((response) => {
      if (response.data.success) {
        dispatch(editUserProductSuccess(
          response.data,
        ));
        Router.push('/cabinet/gallery', '/cabinet/gallery', { shallow: true });
        NotificationManager.success('Product saved');
      }
    }).catch((error) => {
      dispatch(editUserProductFail(error));
    });
};

const getCurrentUserProductStart = () => ({ type: actionTypes.GET_CURRENT_USER_PRODUCT_START });
const getCurrentUserProductSuccess = (payload) => ({
  type: actionTypes.GET_CURRENT_USER_PRODUCT_SUCCESS,
  payload,
});
const getCurrentUserProductFail = (error) => ({
  type: actionTypes.GET_CURRENT_USER_PRODUCT_FAIL, error,
});
const removeCurrentUserProduct = () => ({ type: actionTypes.REMOVE_CURRENT_USER_PRODUCT });

const getCurrentUserProduct = (productLink, token) => (dispatch) => {
  dispatch(getCurrentUserProductStart());

  return getCurrentUserProductApi(productLink, token)
    .then((response) => {
      if (response.data.success) {
        dispatch(getCurrentUserProductSuccess(response.data));
      }
    })
    .catch((error) => {
      dispatch(getCurrentUserProductFail(error));
    });
};

const sendProductComplaintStart = () => ({ type: actionTypes.SEND_PRODUCT_COMPLAINT_START });
const sendProductComplaintSuccess = (payload) => ({
  type: actionTypes.SEND_PRODUCT_COMPLAINT_SUCCESS,
  payload,
});
const sendProductComplaintFail = (error) => ({
  type: actionTypes.SEND_PRODUCT_COMPLAINT_FAIL, error,
});
const sendProductComplaintDiscard = () => ({ type: actionTypes.SEND_PRODUCT_COMPLAINT_DISCARD });

const sendProductComplaint = (message, token = null) => (dispatch) => {
  dispatch(sendProductComplaintStart());

  return sendProductComplaintApi(message, token)
    .then((response) => {
      if (response.data.success) {
        dispatch(sendProductComplaintSuccess(response.data));
        NotificationManager.success(response.data.data);
      }
    })
    .catch((error) => {
      dispatch(sendProductComplaintFail(error));
    });
};

const productActions = {
  getAllProducts,
  getCurrentProduct,
  getSimilarProducts,
  getSearchAllProducts,
  createProduct,
  getUserProducts,
  updateUserProductStatus,
  deleteUserProduct,
  removeCurrentProduct,
  editUserProduct,
  getCurrentUserProduct,
  removeCurrentUserProduct,
  sendProductComplaint,
  sendProductComplaintDiscard,
  changeProductInfo,
  getCurrentProductBid,
};

export default productActions;
